var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 512,
    y1: 256,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdbed",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdbed"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m418.32 2.5c-55.666-9.521-178.298 12.183-200.004 105.017-14.431 61.722-14.007 112.075-50.427 113.02-21.67.562-32.97-44.31-62.889-48.001-39.047-4.817-66.145 27.695-83.057 57.138-37.205 64.772-25.571 174.918 23.354 228.632 118.488 130.086 259.197-5.952 319.358-112.309 38.585-68.213 125.637-123.352 143.767-200.248 15.177-64.376-18.503-131.003-90.102-143.249z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m455.47 452.133h-398.94c-8.284 0-15-6.716-15-15v-314.266c0-8.284 6.716-15 15-15h398.94c8.284 0 15 6.716 15 15v314.266c0 8.285-6.715 15-15 15z",
    fill: "#2626bc",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.47 98.87v314.26c0 8.29-6.72 15-15 15h-398.94c-8.28 0-15-6.71-15-15v-314.26c0-8.29 6.72-15 15-15h398.94c8.28 0 15 6.71 15 15z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.47 351.51v61.62c0 8.29-6.72 15-15 15h-398.94c-8.28 0-15-6.71-15-15v-20.02c23.98-1.18 56.21-7.32 78.89-29.06 40.53-38.86 78.11-30.67 138.3 14.65s62.72-103.35 131.99-65.34c33.71 18.5 60.81 30.6 79.76 38.15z",
    fill: "#ffa8cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.47 280.53v132.6c0 8.29-6.72 15-15 15h-398.94c-8.28 0-15-6.71-15-15v-52.35c25.7-3.02 63.37-1.84 102.79 18.81 70.97 37.16 100.32-57.44 175.18-28.72 63.4 24.32 86.03-62.72 150.97-70.34z",
    fill: "#9fb0fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.47 153.18v-54.313c0-8.284-6.716-15-15-15h-398.94c-8.284 0-15 6.716-15 15v54.313z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 433.133h-398.94c-11.028 0-20-8.972-20-20v-314.266c0-11.028 8.972-20 20-20h398.94c11.028 0 20 8.972 20 20v314.266c0 11.028-8.972 20-20 20zm-398.94-344.266c-5.514 0-10 4.486-10 10v314.266c0 5.514 4.486 10 10 10h398.94c5.514 0 10-4.486 10-10v-314.266c0-5.514-4.486-10-10-10z",
    fill: "#2626bc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 85.623,
    cy: 120.768,
    fill: "#ff5ba8",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.424,
    cy: 120.768,
    fill: "#fff",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.224,
    cy: 120.768,
    fill: "#02ffb3",
    r: 10.901
  })), /*#__PURE__*/React.createElement("path", {
    d: "m432.277 133.015h-136.158v-24.495h136.159c2.761 0 5 2.239 5 5v14.496c-.001 2.761-2.239 4.999-5.001 4.999z",
    fill: "#d2deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.789 108.831c-5.286-5.286-13.887-5.286-19.173 0s-5.286 13.887 0 19.173c4.037 4.037 10.003 4.98 14.953 2.852l4.348 4.348c1.952 1.952 5.119 1.952 7.071 0s1.952-5.119 0-7.071l-4.348-4.348c2.129-4.951 1.186-10.917-2.851-14.954zm-12.102 7.071c1.387-1.387 3.644-1.387 5.031 0s1.387 3.644 0 5.031-3.644 1.387-5.031 0-1.387-3.644 0-5.031z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m281.578 205.134h-97.757c-6.022 0-10.904-4.882-10.904-10.904 0-6.022 4.882-10.904 10.904-10.904h97.757c6.022 0 10.904 4.882 10.904 10.904 0 6.022-4.882 10.904-10.904 10.904z",
    fill: "#ffa8cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.696 205.134h-46.757c-6.022 0-10.904-4.882-10.904-10.904 0-6.022 4.882-10.904 10.904-10.904h46.757c6.022 0 10.904 4.882 10.904 10.904-.001 6.022-4.883 10.904-10.904 10.904z",
    fill: "#9fb0fe"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m308.011 212.699c-.807 0-1.624-.195-2.383-.608-2.427-1.318-3.324-4.354-2.005-6.78l14.078-25.897c1.318-2.427 4.353-3.327 6.78-2.005 2.427 1.318 3.324 4.354 2.005 6.78l-14.078 25.897c-.906 1.668-2.624 2.613-4.397 2.613z",
    fill: "#ff7eb8"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#6583fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m186.011 234.84h-5.332c-6.508 0-11.803 5.295-11.803 11.803v16.457c0 6.508 5.295 11.802 11.803 11.802h5.332c6.508 0 11.803-5.294 11.803-11.802v-16.457c-.001-6.508-5.296-11.803-11.803-11.803zm1.802 28.26c0 .993-.809 1.802-1.803 1.802h-5.332c-.994 0-1.803-.809-1.803-1.802v-16.457c0-.994.809-1.803 1.803-1.803h5.332c.994 0 1.803.809 1.803 1.803z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.491 264.462h-5.184c3.195-3.311 6.24-7.032 7.593-10.307 1.887-4.564 1.447-9.632-1.176-13.555-2.448-3.66-6.42-5.76-10.899-5.76-7.412 0-13.442 6.03-13.442 13.442 0 2.762 2.239 5 5 5s5-2.238 5-5c0-1.898 1.544-3.442 3.442-3.442 1.131 0 2.002.443 2.587 1.318.752 1.125.847 2.725.247 4.176-1.561 3.776-9.363 11.178-14.406 15.228-1.654 1.329-2.291 3.557-1.586 5.559.704 2.001 2.594 3.341 4.716 3.341h18.108c2.761 0 5-2.238 5-5s-2.239-5-5-5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m125.491 262.563h-20.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h20.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.491 282.836h-122.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h122.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#9fb0fe"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#ff7eb8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m366.96 234.62h-5.332c-6.508 0-11.803 5.295-11.803 11.803v16.457c0 6.508 5.295 11.803 11.803 11.803h5.332c6.508 0 11.802-5.295 11.802-11.803v-16.457c0-6.508-5.295-11.803-11.802-11.803zm1.802 28.26c0 .994-.809 1.803-1.802 1.803h-5.332c-.994 0-1.803-.809-1.803-1.803v-16.457c0-.994.809-1.803 1.803-1.803h5.332c.994 0 1.802.809 1.802 1.803z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.19 247.135c0-6.9-5.614-12.515-12.515-12.515h-9.395c-2.761 0-5 2.238-5 5s2.239 5 5 5h9.395c1.387 0 2.515 1.128 2.515 2.515s-1.128 2.516-2.515 2.516h-9.395c-2.761 0-5 2.238-5 5s2.239 5 5 5h9.395c1.387 0 2.515 1.129 2.515 2.516s-1.128 2.516-2.515 2.516h-9.395c-2.761 0-5 2.238-5 5s2.239 5 5 5h9.395c6.901 0 12.515-5.614 12.515-12.516 0-2.822-.95-5.42-2.531-7.516 1.581-2.096 2.531-4.694 2.531-7.516z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m305.19 262.563h-20.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h20.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.19 282.836h-122.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h122.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#9fb0fe"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.228 367.198h-32.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h32.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 223.549,
    cy: 356.497,
    fill: "#ff5ba8",
    r: 5.002
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m422.961 341.496h-32.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h32.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 390.282,
    cy: 330.796,
    fill: "#ff5ba8",
    r: 5.002
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m204.383 51.827c-7.88 0-14.292-6.411-14.292-14.291 0-7.881 6.411-14.292 14.292-14.292 7.88 0 14.291 6.411 14.291 14.292 0 7.88-6.411 14.291-14.291 14.291zm0-18.583c-2.366 0-4.292 1.926-4.292 4.292s1.925 4.291 4.292 4.291 4.291-1.925 4.291-4.291-1.925-4.292-4.291-4.292z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.876 64.119c-7.88 0-14.292-6.411-14.292-14.292 0-7.88 6.411-14.291 14.292-14.291 7.88 0 14.291 6.411 14.291 14.291 0 7.881-6.411 14.292-14.291 14.292zm0-18.583c-2.366 0-4.292 1.925-4.292 4.291s1.925 4.292 4.292 4.292 4.291-1.926 4.291-4.292-1.924-4.291-4.291-4.291z",
    fill: "#ff5ba8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.317 482.421c-2.761 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.761 0-5-2.238-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.239-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.238 5 5s-2.239 5-5 5c-3.309 0-6 2.691-6 6 0 2.762-2.239 5-5 5z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.765 53.827c-2.761 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.761 0-5-2.238-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.239-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.238 5 5s-2.239 5-5 5c-3.309 0-6 2.691-6 6 0 2.762-2.239 5-5 5z",
    fill: "#ff5ba8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.19 493.421c-2.761 0-5-2.238-5-5 0-3.309-2.692-6-6-6-2.761 0-5-2.238-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.239-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.238 5 5s-2.239 5-5 5c-3.308 0-6 2.691-6 6 0 2.762-2.239 5-5 5z",
    fill: "#6583fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.3429b21c961fcb669a700615495708e8.svg";
export { ForwardRef as ReactComponent };